import React from 'react';
import SurveysHub from '../surveys/SurveysHub';

interface MemberSurveysProps {
    memberData?: any;
}

const MemberSurveys: React.FC<MemberSurveysProps> = ({ memberData }) => {
    const memberId = memberData?.id || 'member-id-placeholder';

    return (
        <div className="min-h-screen bg-gray-50">
            <SurveysHub memberId={memberId} />
        </div>
    );
};

export default MemberSurveys;